import { Component, ElementRef, ViewChild } from '@angular/core';
import { jsPDF } from 'jspdf';
import { ApiService } from '../shared/services/api.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatModule } from '../appModules/mat.module';
import { CommonService } from '../shared/services/common.service';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import { DomSanitizer } from '@angular/platform-browser';



interface YearOption {
  value: string;
  Text: string;
}

@Component({
  selector: 'app-grade-card',
  imports: [ReactiveFormsModule, MatInput, MatModule, MatSelectModule, MatFormFieldModule, MatInputModule, CommonModule],
  templateUrl: './grade-card.component.html',
  styleUrl: './grade-card.component.scss'
})
export class GradeCardComponent {
  // photoPath='https://bvvsresults.s3.us-east-005.backblazeb2.com/StudentPhotos/BVVSPEMP205133_Image.jpg';
  pageSize = 5;
  currentPage = 1;
  paginatedResults = [];
  getExamResultData = []; // Your data source
  showProgress = false;
  progressPercent = 0;
  processedCount = 0;
  totalToProcess = 0;
  estimatedTime = '';
  cancelRequested = false;
  isProcessing = false;
  imageUrl: string | any[] = [];

  qrData: string = "http://localhost:4200/Grade-card";

  readonly rowCount = 15;
  readonly bridgeCourseRowCount = 3;

  isregNumWiseGradeCard = false;
  @ViewChild('contentToConvert')
  contentToConvert!: ElementRef;


  examResults: any[] = [];

  Value!: object;
  NoOfPdf = 0;

  getFilteredExamResultData: any;

  EYMStatus!: boolean;

  startYear!: number;

  display = true;
  months: any;
  yearss: any

  CurrentSem: any = 0;


  getSingleExamResultData = null;

  isTableVisible: Record<number, boolean> = {};

  sem6Data: any;

  years!: number[];
  safePhotoUrl: any;

  isLoading: boolean = false;
  DateOfResult: any;
  photo: string = "";
  semesterNumbers: any = [];
  courseNames: any = [];


  isResultDisplayed = false;
  firstNonNullIndex: number = -1;
  index: number = 1;


  @ViewChild('GridView') GridView: any;
  getExamResultData_PUC: any;
  getExamResultData_ITI: any;
  i: any;


  constructor(private apiService: ApiService, private fb: FormBuilder, private common: CommonService, private sanitizer: DomSanitizer) {
    this.startYear = new Date().getFullYear();
  }


  public cYear: number = new Date().getFullYear();

  public currentYear: Array<YearOption> = [
    { value: "0", Text: "Select" },
    { value: this.cYear.toString(), Text: this.cYear.toString() },
    { value: (this.cYear - 1).toString(), Text: (this.cYear - 1).toString() },
    { value: (this.cYear - 2).toString(), Text: (this.cYear - 2).toString() },
    { value: (this.cYear - 3).toString(), Text: (this.cYear - 3).toString() },
    { value: (this.cYear - 4).toString(), Text: (this.cYear - 4).toString() },
    { value: (this.cYear - 5).toString(), Text: (this.cYear - 5).toString() },
    { value: (this.cYear - 6).toString(), Text: (this.cYear - 6).toString() }
  ];

  gradeCardForm: FormGroup;

  ngOnInit(): void {
    this.updatePaginatedResults();
    this.isregNumWiseGradeCard = false;
    this.gradeCardForm = this.fb.group({
      selectedMonth: ['', Validators.required],
      selectedYear: ['', Validators.required],
      selectedReg: [''],
      selectCourse: ['', Validators.required],
      selectSem: ['']
    });

    this.getCourseDropDOwn();
    this.getSemesterDropdown();
    this.year_list();
    this.month_list();
  }


  Display() {
    if (this.isregNumWiseGradeCard) {
      const regNo = this.gradeCardForm.get('selectedReg')?.value?.toString();
      if (!this.validateRegistrationNumber(regNo)) {
        alert('Registration No. should be in the format 11AA111');
        return;
      }
    }

    const data = this.gradeCardForm.value;

    this.isLoading = true;
    this.isResultDisplayed = false;
    if (this.isregNumWiseGradeCard) {
      this.apiService.post('results/getSingleGradeCard', data).subscribe(response => {
        if (response.success) {
          if (!response || Object.keys(response).length === 0) {
            alert('Result is not available for this Register Number for the selected Month and Year!');
            return;
          }
          this.isLoading = false;
          this.isResultDisplayed = true;
          this.getSingleExamResultData = response?.data || [];
          const photoUrl = this.getSingleExamResultData.Studentphoto;

          if (photoUrl) {
            this.safePhotoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(photoUrl);
          }
          //  this.safePhotoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSingleExamResultData.Studentphoto);


        }
      });
    } else {
      this.apiService.post('results/getGradeCardResultSemWise', data).subscribe({
        next: (response) => {
          this.isLoading = false;

          if (!response || Object.keys(response).length === 0) {
            alert('Result is not available for this Register Number for the selected Month and Year!');
            return;
          }

          this.isResultDisplayed = true;


          this.getExamResultData = response?.data || [];


          this.getExamResultData.forEach(student => {
            if (student.Studentphoto) {
              student.safePhotoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(student.Studentphoto);
            }
          });

          this.currentPage = 1; // Reset to page 1 on new result load
          this.updatePaginatedResults();


          this.photo = `https://resultold.bvvspolytech.com/assets/205/1/${response.Photo}`;

          console.log("photo path is:", this.photo);
        },

        error: (error) => {
          this.isLoading = false;
          console.error('Error occurred:', error);

          if (error.status === 404) {
            alert('Result not found for the given Register Number.');
          } else if (error.status === 500) {
            alert('Server error occurred. Please Contact Admin.');
          } else {
            alert('An unexpected error occurred. Please try again later.');
          }
        }
      });
    }
  }

  updatePaginatedResults() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedResults = this.getExamResultData.slice(start, end);
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updatePaginatedResults();
  }

  get totalPages(): number[] {
    return Array(Math.ceil(this.getExamResultData.length / this.pageSize))
      .fill(0)
      .map((_, i) => i + 1);
  }

  private validateRegistrationNumber(registrationNumber: string): boolean {
    const pattern = /^[0-9]{2}[A-Za-z]{2,3}[0-9]{2,3}$/;
    return pattern.test(registrationNumber);
  }






  reloadPage() {
    this.gradeCardForm.reset();
  }


  DownLoadPdf() {
    const register_no = this.gradeCardForm.get('selectedReg')?.value?.toString();
    const semNo = this.getSingleExamResultData.semNo;
    const contentToConvert = document.getElementById('singleProvisional');

    if (contentToConvert) {
      const staticFields = contentToConvert.querySelectorAll('.static-field');
      const tableCells = contentToConvert.querySelectorAll('td, th');
      const tableRows = contentToConvert.querySelectorAll('tr');

      // Store original styles to restore later
      const originalStyles: { element: HTMLElement, border: string | null, visibility?: string | null }[] = [];

      // Hide static fields
      staticFields.forEach(el => {
        const element = el as HTMLElement;
        originalStyles.push({ element, border: null, visibility: element.style.visibility });
        element.style.visibility = 'hidden';
      });

      // Remove borders from td, th, tr
      tableCells.forEach(el => {
        const element = el as HTMLElement;
        originalStyles.push({ element, border: element.style.border });
        element.style.border = 'none';
      });

      tableRows.forEach(el => {
        const element = el as HTMLElement;
        originalStyles.push({ element, border: element.style.border });
        element.style.border = 'none';
      });

      const pdf = new jsPDF('p', 'mm', 'a4');
      const options = { allowTaint: false, useCORS: true };

      html2canvas(contentToConvert, options).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;

        const scale = Math.min(pdfWidth / contentWidth, pdfHeight / contentHeight);
        const xOffset = (pdfWidth - contentWidth * scale) / 2;
        const yOffset = (pdfHeight - contentHeight * scale) / 2;

        pdf.addImage(imgData, 'JPEG', xOffset, yOffset, contentWidth * scale, contentHeight * scale);
        pdf.save(`GradeCard_SEM_${semNo}_${register_no}.pdf`);

        // Restore all original styles
        originalStyles.forEach(({ element, border, visibility }) => {
          if (visibility !== undefined) element.style.visibility = visibility!;
          if (border !== null) element.style.border = border;
        });
      }).catch((error) => {
        console.error('Error generating PDF:', error);
        // Restore even on error
        originalStyles.forEach(({ element, border, visibility }) => {
          if (visibility !== undefined) element.style.visibility = visibility!;
          if (border !== null) element.style.border = border;
        });
      });
    } else {
      console.error("Element with ID 'singleProvisional' not found.");
    }
  }

  // async DownloadPdfJSPDF() {
  //   const semester = this.getSingleExamResultData;
  //   const register_no = this.gradeCardForm.get('selectedReg')?.value?.toString();
  //   const semNo = semester?.semNo || 'Unknown';
  //   this.firstSemSeparatorShown = false
  //   const doc = new jsPDF('p', 'mm', 'a4');
  //   doc.setFontSize(12);
  //   doc.setFont('Times', 'Normal');

  //   const photoUrl = semester.Studentphoto;
  //   //const photoUrl = 'https://yaanendriya.s3.us-east-005.backblazeb2.com/banners/BVVSPSTU7080_Image.jpg';
  //   if (photoUrl) {
  //     try {
  //       const imgData = await this.loadImageAsBase64(photoUrl); // helper function defined below
  //       // Place image at top-right (adjust X, Y, W, H as needed)
  //       doc.addImage(imgData, 'JPEG', 171, 15, 25, 30); // X=160mm, Y=65mm, Width=25mm, Height=30mm
  //     } catch (err) {
  //       console.error('Failed to load student photo:', err);
  //     }
  //   }

  //   // Header
  //   doc.text(`${semester.Exam_month} - ${semester.Exam_year}`, 135, 68);
  //   doc.setFontSize(10);
  //   doc.text(`${semester.courseName}`, 53, 73.1);
  //   doc.text(`${semester.studentName}`, 53, 78.68);
  //   doc.text(`${semester.father_name}`, 53, 84.75);
  //   doc.text(`${semester.studentMotherName}`, 53, 91);
  //   doc.text(`${semester.registerNo}`, 167, 96.2);
  //   const formattedDate = new Date(this.DateOfResult || semester.dateOfResult).toLocaleDateString('en-GB');
  //   doc.text(formattedDate, 53, 96.4);

  //   // Subject rows
  //   const subjectList = semester.subjectDetailsList || [];
  //   let y = 113;
  //   let dashedSeparatorDrawn = false;
  //   const currentSem = subjectList.length > 0 ? subjectList[0].sem : null;

  //   subjectList.forEach((sub: any, i: number) => {
  //     const lineHeight = 5;
  //     const maxWidth = 83;

  //     const fullSubject = `${sub.subject_code} ${sub.subject_name}`;
  //     const wrappedText = doc.splitTextToSize(fullSubject, maxWidth);
  //     const numLines = wrappedText.length;

  //     // Draw subject row
  //     doc.text(`${sub.sem}`, 15.5, y);
  //     doc.text(`${sub.SINO}`, 26.5, y);
  //     doc.text(wrappedText, 37, y);
  //     doc.text(`${sub.totalCredits}`, 129, y);
  //     doc.text(`${sub.earnedCredit}`, 149.5, y);
  //     doc.text(`${sub.gradePoints}`, 169, y);
  //     doc.text(`${sub.gradeAwarded}`, 187.5, y);

  //     const currentY = y;
  //     y += numLines * lineHeight;

  //     // Draw separator only once: when next subject has different semester
  //     if (
  //       !dashedSeparatorDrawn &&
  //       i < subjectList.length - 1 &&
  //       sub.sem !== subjectList[i + 1].sem
  //     ) {
  //       doc.setLineWidth(0.2);
  //       doc.setDrawColor(150);
  //       doc.setLineDashPattern([1, 1], 0);
  //       doc.line(12.5, y + 1.5, 200, y + 1.5); // Draw dashed line
  //       doc.setLineDashPattern([], 0); // Reset dash
  //       y += 7; // Add space after line
  //       dashedSeparatorDrawn = true; // ✅ Ensure it's drawn only once
  //     }
  //   });

  //   doc.setFontSize(9);
  //   // ---------------------------------------
  //   // ✅ Add Credits Applied to SGPA Section
  //   // ---------------------------------------
  //   let sgpaStartY = 217.3;
  //   const semData = semester.semWiseCumilativeResult || [];
  //   const semTitles = ['I', 'II', 'III', 'IV', 'V', 'VI'];

  //   // Row 1: Credits Applied
  //   //  doc.text('Credits Applied', 20, sgpaStartY);
  //   semTitles.forEach((label, i) => {
  //     doc.text(`${semData[i]?.TotalCreditsForSem || '-'}`, 44.3 + i * 13.5, sgpaStartY);
  //   });
  //   // doc.text('Credits Earned', 135, sgpaStartY);
  //   doc.text(`${semester?.cumulative_credits_earned || '-'}`, 170, sgpaStartY);

  //   // Row 2: Credits Earned per sem
  //   sgpaStartY += 5;
  //   // doc.text('Credits Earned', 20, sgpaStartY);
  //   semTitles.forEach((label, i) => {
  //     doc.text(`${semData[i]?.sem_credits_earned || '-'}`, 44.3 + i * 13.5, sgpaStartY);
  //   });
  //   // doc.text('CGPA', 135, sgpaStartY);
  //   doc.text(`${semester.cgpa || '-'}`, 170, sgpaStartY);

  //   // Row 3: Σ(CiXGi)
  //   sgpaStartY += 5;
  //   // doc.text('Σ(CiXGi)', 20, sgpaStartY);
  //   semTitles.forEach((label, i) => {
  //     doc.text(`${semData[i]?.sem_weighted_average || '-'}`, 44.3 + i * 13.5, sgpaStartY);
  //   });
  //   // doc.text('% Conversion', 135, sgpaStartY);
  //   doc.text(`${semester.total_percentage || '-'}`, 170, sgpaStartY);

  //   // Row 4: SGPA (Attempts)
  //   sgpaStartY += 5;
  //   // doc.text('SGPA (Attempts)', 20, sgpaStartY);
  //   semTitles.forEach((label, i) => {
  //     const sgpa = semData[i]?.sem_SGPA || '-';
  //     const attempts = semData[i]?.sem_attempt_count || '';
  //     const attemptText = attempts ? `${sgpa} (${attempts})` : sgpa;
  //     const xPos = attemptText === '-' ? 44.3 + i * 13.5 : 42.7 + i * 13.5;
  //     doc.text(attemptText, xPos, sgpaStartY);
  //   });
  //   //  doc.text('Result', 135, sgpaStartY);
  //   doc.text(`${semester.overall_result || '-'}`, 170, sgpaStartY);

  //   doc.setFontSize(10);
  //   // ---------------------------------------
  //   // ✅ Add Bridge Course Section
  //   // ---------------------------------------
  //   let bridgeStartY = sgpaStartY + 17;
  //   //   doc.text('Bridge Course / Audit Course Without Credits', 20, bridgeStartY);
  //   // bridgeStartY += 7;

  //   const bridgeList = semester.NonCreditSemResult || [];
  //   bridgeList.forEach((sub: any, idx: number) => {
  //     const lineHeight = 5;
  //     const maxWidth = 120; // adjust if needed based on layout

  //     const fullSubject = `${sub.subject_code} ${sub.subject_name}`;
  //     const wrappedText = doc.splitTextToSize(fullSubject, maxWidth);
  //     const numLines = wrappedText.length;

  //     doc.text(`${sub.sem}`, 15, bridgeStartY);
  //     doc.text(`${idx + 1}`, 26, bridgeStartY);
  //     doc.text(wrappedText, 35, bridgeStartY); // Wraps subject name
  //     const result = (sub.result || '').toLowerCase();
  //     doc.text(result === 'p' || result === 'pass' ? 'PASS' : 'FAIL', 173, bridgeStartY);

  //     bridgeStartY += numLines * lineHeight; // Move Y down based on wrapped lines
  //   });
  //   if (bridgeList.length === 0) {
  //     doc.text('No Bridge Course Result', 60, bridgeStartY);
  //   }

  //   // Save the final PDF
  //   doc.save(`GradeCard_SEM_${semNo}_${register_no}.pdf`);
  // }


  async DownloadPdfJSPDF() {
    const semester = this.getSingleExamResultData;
    const register_no = this.gradeCardForm.get('selectedReg')?.value?.toString() || 'UNKNOWN';
    const blob = await this.generateStudentPdf(semester, register_no);
    saveAs(blob, `GradeCard_SEM_${semester?.semNo}_${register_no}.pdf`);
  }


  getCourseDropDOwn() {
    this.apiService.get(`settings/courseDropDown`).subscribe((resp: any) => {
      if (resp.status) {
        this.courseNames = resp.data;

      } else {
        this.common.notification(resp.message);
      }
    });
  }
  getSemesterDropdown() {
    this.apiService.get(`settings/semesterDropDown`).subscribe((resp: any) => {
      if (resp.status) {

        this.semesterNumbers = resp.data;
      } else {
        this.common.notification(resp.message);
      }
    });
  }

  CourseWiseDisplay() {
    this.isregNumWiseGradeCard = false;

  }
  registerNoWiseDisplay() {
    this.isregNumWiseGradeCard = true;

  }

  year_list() {
    this.apiService.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.yearss = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.apiService.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }
  // async startBatchDownload(): Promise<void> {
  //   const currentData = this.paginatedResults;
  //   const total = currentData.length;

  //   if (total === 0) {
  //     alert('No records to download.');
  //     return;
  //   }

  //   this.totalToProcess = total;
  //   this.processedCount = 0;
  //   this.progressPercent = 0;
  //   this.showProgress = true;
  //   this.cancelRequested = false;
  //   this.isProcessing = true;

  //   const zip = new JSZip();
  //   const startTime = Date.now();

  //   for (let i = 0; i < total; i++) {
  //     if (this.cancelRequested) {
  //       this.resetProgress();
  //       return;
  //     }

  //     const contentId = `contentToConvertProvisional${i}`;
  //     const element = document.getElementById(contentId);
  //     if (!element) continue;

  //     // Prepare elements
  //     const staticFields = element.querySelectorAll('.static-field');
  //     const tableCells = element.querySelectorAll('td, th');
  //     const tableRows = element.querySelectorAll('tr');

  //     const originalStyles: { element: HTMLElement, border: string | null, visibility?: string | null }[] = [];

  //     // Hide static fields
  //     staticFields.forEach(el => {
  //       const elmt = el as HTMLElement;
  //       originalStyles.push({ element: elmt, border: null, visibility: elmt.style.visibility });
  //       elmt.style.visibility = 'hidden';
  //     });

  //     // Remove borders from table cells
  //     tableCells.forEach(el => {
  //       const elmt = el as HTMLElement;
  //       originalStyles.push({ element: elmt, border: elmt.style.border });
  //       elmt.style.border = 'none';
  //     });

  //     // Remove borders from table rows
  //     tableRows.forEach(el => {
  //       const elmt = el as HTMLElement;
  //       originalStyles.push({ element: elmt, border: elmt.style.border });
  //       elmt.style.border = 'none';
  //     });

  //     // Now generate the canvas after hiding and removing borders
  //     const canvas = await html2canvas(element, { scale: 2 } as any);
  //     const imgData = canvas.toDataURL('image/png');

  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     const blob = pdf.output('blob');

  //     zip.file(`GradeCard_Page_${this.currentPage}_Item_${i + 1}.pdf`, blob);

  //     // Restore original styles
  //     originalStyles.forEach(({ element, border, visibility }) => {
  //       if (visibility !== undefined) element.style.visibility = visibility;
  //       if (border !== null) element.style.border = border;
  //     });

  //     this.processedCount++;
  //     this.progressPercent = Math.round((this.processedCount / total) * 100);

  //     const elapsed = Date.now() - startTime;
  //     const avgTimePerCard = elapsed / this.processedCount;
  //     const remaining = total - this.processedCount;
  //     this.estimatedTime = `${Math.ceil((avgTimePerCard * remaining) / 1000)}s remaining`;
  //   }

  //   const zipBlob = await zip.generateAsync({ type: 'blob' });
  //   saveAs(zipBlob, `GradeCards_Page_${this.currentPage}.zip`);

  //   this.resetProgress();
  // }


  // async startBatchDownload(): Promise<void> {
  //   const currentData = this.paginatedResults;
  //   const total = currentData.length;

  //   if (total === 0) {
  //     alert('No records to download.');
  //     return;
  //   }

  //   this.totalToProcess = total;
  //   this.processedCount = 0;
  //   this.progressPercent = 0;
  //   this.showProgress = true;
  //   this.cancelRequested = false;
  //   this.isProcessing = true;

  //   const zip = new JSZip();
  //   const startTime = Date.now();

  //   for (let i = 0; i < total; i++) {
  //     if (this.cancelRequested) {
  //       this.resetProgress();
  //       return;
  //     }

  //     const contentId = `contentToConvertProvisional${i}`;
  //     const contentToConvert = document.getElementById(contentId);
  //     if (!contentToConvert) continue;


  //     const staticFields = contentToConvert.querySelectorAll('.static-field');
  //     const tableCells = contentToConvert.querySelectorAll('td, th');
  //     const tableRows = contentToConvert.querySelectorAll('tr');

  //     const originalStyles: { element: HTMLElement, border: string | null, visibility?: string | null }[] = [];

  //     staticFields.forEach(el => {
  //       const element = el as HTMLElement;
  //       originalStyles.push({ element, border: null, visibility: element.style.visibility });
  //       element.style.visibility = 'hidden';
  //     });

  //     tableCells.forEach(el => {
  //       const element = el as HTMLElement;
  //       originalStyles.push({ element, border: element.style.border });
  //       element.style.border = 'none';
  //     });

  //     tableRows.forEach(el => {
  //       const element = el as HTMLElement;
  //       originalStyles.push({ element, border: element.style.border });
  //       element.style.border = 'none';
  //     });


  //     const canvas = await html2canvas(contentToConvert);
  //     const imgData = canvas.toDataURL('image/png');

  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     const blob = pdf.output('blob');

  //     zip.file(`GradeCard_Page_${this.currentPage}_Item_${i + 1}.pdf`, blob);


  //     originalStyles.forEach(({ element, border, visibility }) => {
  //       if (visibility !== undefined) element.style.visibility = visibility;
  //       if (border !== null) element.style.border = border;
  //     });


  //     this.processedCount++;
  //     this.progressPercent = Math.round((this.processedCount / total) * 100);

  //     const elapsed = Date.now() - startTime;
  //     const avgTimePerCard = elapsed / this.processedCount;
  //     const remaining = total - this.processedCount;
  //     this.estimatedTime = `${Math.ceil((avgTimePerCard * remaining) / 1000)}s remaining`;
  //   }

  //   const zipBlob = await zip.generateAsync({ type: 'blob' });
  //   saveAs(zipBlob, `GradeCards_Page_${this.currentPage}.zip`);

  //   this.resetProgress();
  // }

  //Actual code

  // async startBatchDownload(): Promise<void> {
  //   const currentData = this.paginatedResults;
  //   const total = currentData.length;

  //   if (total === 0) {
  //     alert('No records to download.');
  //     return;
  //   }

  //   this.totalToProcess = total;
  //   this.processedCount = 0;
  //   this.progressPercent = 0;
  //   this.showProgress = true;
  //   this.cancelRequested = false;
  //   this.isProcessing = true;

  //   const zip = new JSZip();
  //   const startTime = Date.now();

  //   for (let i = 0; i < total; i++) {
  //     if (this.cancelRequested) {
  //       this.resetProgress();
  //       return;
  //     }

  //     const contentId = `contentToConvertProvisional${i}`;
  //     const contentToConvert = document.getElementById(contentId);
  //     if (!contentToConvert) continue;

  //     // --- Hide .static-field elements and borders of td, th, tr ---
  //     const staticFields = contentToConvert.querySelectorAll('.static-field');
  //     const tableElements = contentToConvert.querySelectorAll('td, th, tr');

  //     const originalStyles: {
  //       element: HTMLElement;
  //       style: { border: string | null; visibility?: string | null };
  //     }[] = [];

  //     staticFields.forEach(el => {
  //       const element = el as HTMLElement;
  //       originalStyles.push({
  //         element,
  //         style: {
  //           border: null,
  //           visibility: element.style.visibility,
  //         },
  //       });
  //       element.style.visibility = 'hidden';
  //     });

  //     tableElements.forEach(el => {
  //       const element = el as HTMLElement;
  //       originalStyles.push({
  //         element,
  //         style: {
  //           border: element.style.border,
  //         },
  //       });
  //       element.style.border = 'none';
  //     });

  //     // --- Capture canvas with scaling for better clarity ---
  //     const canvas = await html2canvas(contentToConvert, { scale: 2 } as any);
  //     const imgData = canvas.toDataURL('image/png');

  //     // --- Generate PDF with max A4 width ---
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     const blob = pdf.output('blob');

  //     zip.file(`GradeCard_Page_${this.currentPage}_Item_${i + 1}.pdf`, blob);

  //     // --- Revert original styles ---
  //     originalStyles.forEach(({ element, style }) => {
  //       if (style.visibility !== undefined) element.style.visibility = style.visibility;
  //       if (style.border !== null) element.style.border = style.border;
  //     });

  //     // --- Progress tracking ---
  //     this.processedCount++;
  //     this.progressPercent = Math.round((this.processedCount / total) * 100);
  //     const elapsed = Date.now() - startTime;
  //     const avgTimePerCard = elapsed / this.processedCount;
  //     const remaining = total - this.processedCount;
  //     this.estimatedTime = `${Math.ceil((avgTimePerCard * remaining) / 1000)}s remaining`;
  //   }

  //   const zipBlob = await zip.generateAsync({ type: 'blob' });
  //   saveAs(zipBlob, `GradeCards_Page_${this.currentPage}.zip`);

  //   this.resetProgress();
  // }

  async startBatchDownload(): Promise<void> {
    const currentData = this.paginatedResults;
    const total = currentData.length;

    if (total === 0) {
      alert('No records to download.');
      return;
    }

    this.totalToProcess = total;
    this.processedCount = 0;
    this.progressPercent = 0;
    this.showProgress = true;
    this.cancelRequested = false;
    this.isProcessing = true;

    const zip = new JSZip();
    const startTime = Date.now();

    for (let i = 0; i < total; i++) {
      if (this.cancelRequested) {
        this.resetProgress();
        return;
      }

      const semester = currentData[i];
      const register_no = semester.registerNo || `REG${i}`;
      const blob = await this.generateStudentPdf(semester, register_no);

      zip.file(`GradeCard_SEM_${semester.semNo || 'Unknown'}_${register_no}.pdf`, blob);

      this.processedCount++;
      this.progressPercent = Math.round((this.processedCount / total) * 100);

      const elapsed = Date.now() - startTime;
      const avgTimePerCard = elapsed / this.processedCount;
      const remaining = total - this.processedCount;
      this.estimatedTime = `${Math.ceil((avgTimePerCard * remaining) / 1000)}s remaining`;
    }


    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, `GradeCards_Page_${this.currentPage}.zip`);
    this.resetProgress();
  }



  cancelDownload() {
    this.cancelRequested = true;
  }

  resetProgress() {
    this.showProgress = false;
    this.progressPercent = 0;
    this.processedCount = 0;
    this.estimatedTime = '';
    this.isProcessing = false;
  }


  getArray(subjects: any[]): any[] {
    const count = Math.max(0, 14 - (subjects?.length || 0));
    return new Array(count);
  }

  // Used for *ngFor trackBy
  trackByIndex(index: number, item: any): number {
    return index;
  }



  firstSemSeparatorShown = false;

  resetSeparatorFlag(): boolean {

    // if(this.getSingleExamResultData.semWiseCumilativeResult?.length >=this.romanToNumber(this.getSingleExamResultData.subjectDetailsList[0].sem)){
    this.firstSemSeparatorShown = false;
    return true;
  }

  shouldShowSeparator(currentSem: number, subjectList: any[], index: number) {
    // if(!this.firstSemSeparatorShown) {

    // return (
    //   index < subjectList.length - 1 &&
    //   currentSem !== subjectList[index + 1].sem
    // );

    // }
  }
  romanToNumber(roman: string): number {
    const map: { [key: string]: number } = {
      I: 1,
      II: 2,
      III: 3,
      IV: 4,
      V: 5,
      VI: 6,
      VII: 7,
      VIII: 8,
      IX: 9,
      X: 10,
    };
    return map[roman] || 0;
  }

  loadImageAsBase64(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'Anonymous');
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg'));
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  async generateStudentPdf(semester: any, register_no: string): Promise<Blob> {
    const semNo = semester?.semNo || 'Unknown';
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.setFont('Times', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    // Load and add student photo
    // const photoUrl = semester.Studentphoto;
    // if (photoUrl) {
    //   try {
    //     const imgData = await this.loadImageAsBase64(photoUrl);
    //     doc.addImage(imgData, 'JPEG', 170.7, 14.2, 25, 30); // X, Y, Width, Height
    //   } catch (err) {
    //     console.error(`Photo load failed for ${register_no}`, err);
    //   }
    // }

    // Header
    doc.text(`${semester.Exam_month} - ${semester.Exam_year}`, 135, 67.3);
    doc.setFontSize(10);
    doc.text(`${semester.courseName}`, 55, 73.3);
    doc.text(`${semester.studentName}`, 55, 78.3);
    doc.text(`${semester.father_name}`, 55, 84);
    doc.text(`${semester.studentMotherName}`, 55, 89.5);
    doc.text(`${semester.registerNo}`, 167, 96);
    const formattedDate = new Date(semester.dateOfResult).toLocaleDateString('en-GB');
    doc.text(formattedDate, 55, 95.8);

    // Subject rows
    const subjectList = semester.subjectDetailsList || [];
    let y = 113;
    let dashedSeparatorDrawn = false;

    const romanToInt = (roman: string): number => {
      const map: Record<string, number> = {
        'I': 1, 'II': 2, 'III': 3, 'IV': 4, 'V': 5, 'VI': 6,
        'VII': 7, 'VIII': 8, 'IX': 9, 'X': 10
      };
      return map[roman.toUpperCase()] || 0;
    };

    const highestSemSubject = subjectList.reduce((maxSub, currentSub) => {
      return romanToInt(currentSub.sem) > romanToInt(maxSub.sem) ? currentSub : maxSub;
    }, subjectList[0]);

    const drawTopSeparator = highestSemSubject?.appearedAs === 'P';

    if (drawTopSeparator) {
      doc.setLineWidth(0.2);
      doc.setDrawColor(150);
      doc.setLineDashPattern([1, 1], 0);
      doc.line(32.5, y - 2, 119, y - 2); // line above the first row
      doc.setLineDashPattern([], 0);
      y += 7;
      dashedSeparatorDrawn = true;
    }

    subjectList.forEach((sub: any, i: number) => {
      const lineHeight = 5;
      const maxWidth = 78;
      const fullSubject = `${sub.subject_code}   ${sub.subject_name}`;
      const wrappedText = doc.splitTextToSize(fullSubject, maxWidth);
      const numLines = wrappedText.length;

      doc.text(`${sub.sem}`, 15.5, y);
      doc.text(`${sub.SINO}`, 26.3, y);
      doc.text(wrappedText, 35.3, y);
      doc.text(`${sub.totalCredits}`, 129, y);
      doc.text(`${sub.earnedCredit}`, 149.5, y);
      doc.text(`${sub.gradePoints}`, 169, y);
      doc.text(`${sub.gradeAwarded}`, 186.9, y);

      y += numLines * lineHeight;

      if (!drawTopSeparator && !dashedSeparatorDrawn && i < subjectList.length - 1 &&
        sub.sem !== subjectList[i + 1].sem) {
        doc.setLineWidth(0.2);
        doc.setDrawColor(150);
        doc.setLineDashPattern([1, 1], 0);
        doc.line(32.5, y + 1.5, 119, y + 1.5);
        doc.setLineDashPattern([], 0);
        y += 7;
        dashedSeparatorDrawn = true;
      }
    });

    // SGPA Table
    doc.setFontSize(8.5);
    let sgpaStartY = 218;
    const semData = semester.semWiseCumilativeResult || [];
    const semTitles = ['I', 'II', 'III', 'IV', 'V', 'VI'];

    semTitles.forEach((_, i) => {
      doc.text(`${semData[i]?.TotalCreditsForSem || ''}`, 45 + i * 13.5, sgpaStartY);
    });
    doc.text(`${semester?.cumulative_credits_earned || ''}`, 168, sgpaStartY);

    sgpaStartY += 5;
    semTitles.forEach((_, i) => {
      doc.text(`${semData[i]?.sem_credits_earned || ''}`, 45 + i * 13.5, sgpaStartY);
    });
    //    doc.text(`${semester.cgpa || '-'}`, 168, sgpaStartY);
    const cgpaText = semester.cgpa || '';
    const isCreditText = cgpaText.toLowerCase().startsWith('credit');
    const cgpaX = isCreditText ? 160 : 168; // move 4mm left if it's 'Credit...'
    doc.text(cgpaText, cgpaX, sgpaStartY);

    sgpaStartY += 5;
    semTitles.forEach((_, i) => {
      doc.text(`${semData[i]?.sem_weighted_average || ''}`, 45 + i * 13.5, sgpaStartY);
    });
    // doc.text(`${semester.total_percentage || '-'}`, 168, sgpaStartY);
    const percentText = semester.total_percentage || '';
    const isPercentText = percentText.toLowerCase().startsWith('not');
    const percentX = isPercentText ? 162 : 168; // move 4mm left if it's 'Credit...'
    doc.text(percentText, percentX, sgpaStartY);


    sgpaStartY += 5;
    semTitles.forEach((_, i) => {
      const regNo = semester?.registerNo || '';
      const isOldBatch = regNo.startsWith('18') || regNo.startsWith('19') || regNo.startsWith('20');

      const sgpaRaw = semData[i]?.sem_SGPA;
      const attempts = semData[i]?.sem_attempt_count;

      const isSgpaMissing = sgpaRaw == null || sgpaRaw === '' || sgpaRaw === '--';
      let displayText = '';

      if (isSgpaMissing && isOldBatch) {
        displayText = '--';
      } else if (sgpaRaw === '--') {
        displayText = '--';
      } else if (!isSgpaMissing) {
        displayText = `${sgpaRaw}`;
        if (attempts !== '') {
          displayText += ` (${attempts})`;
        }
      }

      if (displayText && displayText !== '') {
    const xPos = 43 + i * 13.5; // Adjust this if needed
    doc.text(displayText, xPos, sgpaStartY);
  }
    });

    doc.text(`${semester.overall_result || ''}`, 167, sgpaStartY);

    // Bridge Courses
    doc.setFontSize(10);
    let bridgeStartY = sgpaStartY + 17;
    const bridgeList = semester.NonCreditSemResult || [];

    bridgeList.forEach((sub: any, idx: number) => {
      const lineHeight = 5;
      const maxWidth = 120;
      const fullSubject = `${sub.subject_code} ${sub.subject_name}`;
      const wrappedText = doc.splitTextToSize(fullSubject, maxWidth);
      const numLines = wrappedText.length;

      doc.text(`${sub.sem}`, 15, bridgeStartY);

      // ✅ FIXED SERIAL NUMBER
      doc.text(`${idx + 1}`, 26, bridgeStartY);

      doc.text(wrappedText, 35, bridgeStartY);

      const result = (sub.result || '').toLowerCase();
      doc.text(
        result === 'p' || result === 'pass' ? 'PASS' : 'FAIL',
        173,
        bridgeStartY
      );

      bridgeStartY += numLines * lineHeight;
    });
    // if (bridgeList.length === 0) {
    //   doc.text('No Bridge Course Result', 60, bridgeStartY);
    // }

    return doc.output('blob');
  }





}
